import React, { useRef, useEffect, useState } from "react";
import styles from "./DashboardHeader.module.css";
import { Button, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const categories = [
  { name: "Anime", icon: "✨" },
  { name: "Architecture", icon: "🏛️" },
  { name: "Character", icon: "👤" },
  { name: "Nature", icon: "🌿" },
  { name: "Fantasy", icon: "🧙" },
  { name: "Sci-Fi", icon: "🚀" },
  { name: "Cyberpunk", icon: "🕶️" },
  { name: "Abstract", icon: "🎨" },
];

const DashboardHeader = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [activeCategory, setActiveCategory] = useState(categories[0].name);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    };

    const handleResize = () => handleScroll();
    
    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();
    
    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={styles.headerContainer}>
      <div className={styles.right}>
        <IconButton 
          className={`${styles.navButton} ${styles.leftNav} ${
            !canScrollLeft ? styles.hidden : ""
          }`}
          onClick={() => scroll("left")}
        >
          <ArrowBackIos className={styles.arrowIcon} />
        </IconButton>

        <div 
          className={`${styles.categoryContainer} 
            ${canScrollLeft ? styles.canScrollLeft : ""} 
            ${canScrollRight ? styles.canScrollRight : ""}`}
          ref={scrollRef}
        >
          {categories.map((cat) => (
            <Button 
              key={cat.name} 
              className={`${styles.category} ${
                activeCategory === cat.name ? styles.active : ""
              }`}
              onClick={() => setActiveCategory(cat.name)}
            >
              <span className={styles.icon}>{cat.icon}</span>
              {cat.name}
            </Button>
          ))}
        </div>

        <IconButton 
          className={`${styles.navButton} ${styles.rightNav} ${
            !canScrollRight ? styles.hidden : ""
          }`}
          onClick={() => scroll("right")}
        >
          <ArrowForwardIos className={styles.arrowIcon} />
        </IconButton>
      </div>
    </div>
  );
};

export default DashboardHeader;